import Profile from './Profile'
import Appointments from './Appointment'
import Patients from './Patients'

export default {
  appointments: Appointments,
  profile: Profile,
  patients: Patients
}
